
import React, { useState, useEffect } from "react";
import { cn } from "@/lib/utils";

interface OptimizedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  className?: string;
  containerClassName?: string;
  blurDataUrl?: string;
}

export function OptimizedImage({
  src,
  alt,
  className,
  containerClassName,
  blurDataUrl,
  ...props
}: OptimizedImageProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [currentSrc, setCurrentSrc] = useState(blurDataUrl || src);

  // Load image on mount and when src changes
  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setIsLoading(false);
      setCurrentSrc(src);
    };
    return () => {
      img.onload = null;
    };
  }, [src]);

  return (
    <div className={cn("relative overflow-hidden", containerClassName)}>
      <img
        src={currentSrc}
        alt={alt}
        className={cn(
          className,
          isLoading && "scale-110 blur-sm",
          "transition-all duration-300"
        )}
        {...props}
      />
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-muted/20">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent"></div>
        </div>
      )}
    </div>
  );
}
